import styled from "styled-components";

import { PrimaryButton, SecondaryButton } from "components/Button";

export const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 16px;
  margin: 0px auto;
  margin-top: 88px;
`;

export const StyledPageTitle = styled.h1`
  font-family: ThemeFontRegular;
  text-align: center;
  color: ${({ theme }) => theme.customTheme.palette.black.standard};
  font-size: 24px;
  text-align: center;
  line-height: 30px;
`;

export const StyledDescription = styled.h2`
  font-family: ThemeFontRegular;
  text-align: center;
  color: ${({ theme }) => theme.customTheme.palette.black.standard};
  font-size: 16px;
  text-align: center;
  line-height: 22px;
`;

export const StyledBoxArea = styled.section`
  display: flex;
  flex-direction: column;
  padding: 12px;
  gap: 16px;
  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    flex-direction: row;
  }
`;

export const BackToHomepageButton = styled(SecondaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(10)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  height: ${({ theme }) => theme.customTheme.pxToRem(40)};
  width: auto;
  height: auto;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 10px 24px;
  }
`;

export const LoginButton = styled(PrimaryButton)`
  padding: ${({ theme }) => theme.customTheme.pxToRem(10)} ${({ theme }) => theme.customTheme.pxToRem(24)};
  font-size: ${({ theme }) => theme.customTheme.pxToRem(18)};
  height: ${({ theme }) => theme.customTheme.pxToRem(40)};
  width: 100%;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    margin: auto;
    width: fit-content;
  }

  ${({ theme }) => theme.customTheme.breakpoints.up("lg")} {
    width: 22.5%;
  }
`;

export const LoginLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  border: 1px solid red;
  border-radius: 5px;
  background-color: ${({ theme }) => theme.customTheme.palette.red.standard};
  text-align: center;
  padding: 8px 6px;
  color: ${({ theme }) => theme.customTheme.palette.white.standard};
  display: ${({ hidden }) => (hidden ? "none" : "block")};
  font-size: 18px;
  font-family: ThemeFontRegular;
  width: auto;
  height: auto;

  ${({ theme }) => theme.customTheme.breakpoints.up("md")} {
    padding: 10px 24px;
  }
`;

export const IconStyled = styled.i`
  display: flex;
`;
